import { Errored } from 'solid-js';
import { httpStatus, isServer } from '@solidjs/web';

function ErrorFallback(props) {
  console.error(props.error());
  httpStatus(500);
  return (
    <span style="font-size:1.5em;text-align:center;position:fixed;left:0;bottom:55%;width:100%">
      {isServer ? '500 | Internal Server Error' : 'Error | Uncaught Client Exception'}
    </span>
  );
}

export function DefaultErrorBoundary(props) {
  return (
    <Errored fallback={(error) => <ErrorFallback error={error} />}>
      {props.children}
    </Errored>
  );
}